module.exports = __webpack_public_path__ + "img/gift7-05-c1.b1e83e58.png";